import { render, staticRenderFns } from "./Pickers.vue?vue&type=template&id=134b7109&"
import script from "./Pickers.vue?vue&type=script&lang=js&"
export * from "./Pickers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports